module.exports = __webpack_public_path__ + "./img/notsold.050025325d5f5b29890c81cbb292b60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/notsold.png
// module id = ./src/containers/Briefcase/entry/icons/notsold.png
// module chunks = 0